import React, { useMemo, useContext, useState, useLayoutEffect, useRef, useEffect } from 'react';
import { useSpring, animated } from 'react-spring';
import classnames from 'classnames';
import CaretSvg from '../../../assets/svg/nav/caret.svg';
import { trailingSlash } from '../../../utils';
import GlobalContext from '../../../context/global';
import useMeasure from '../../../hooks/useMeasure';
import useResponsive from '../../../hooks/useResponsive';
import SubMenu from '../SubMenu';
import { StyledMenuItem } from './styles';

const MenuDropdown = ({
  label,
  blocks,
  includeBanner,
  banner,
  navigationState,
  setNavigationState,
  subMenuSpring,
  isPreviousItemActive,
}) => {
  const parentNavItem = useRef(null);
  const { location } = useContext(GlobalContext);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [ref, { height }] = useMeasure();
  const { isFullNav } = useResponsive();

  const isOpen = isFullNav ? navigationState.current === label : isMobileOpen;

  // focus on the correct element when opening or exiting a sub menu
  useEffect(() => {
    if (isOpen){
      parentNavItem.current.focus();
    }
    
    if (navigationState.departedFromSubMenu===label){
      parentNavItem.current.parentNode.nextSibling.firstChild.focus();
    }
  }, [navigationState]);

  const toggleSubMenu = () => {
    console.log('toggle sub menu');
    if (isFullNav && isOpen) {
      setNavigationState({
        ...navigationState,
        height: 0,
        current: null,
        stage: 'closed',
        departedFromSubMenu: label,
      });
    } else if (isFullNav && !isOpen) {
      setNavigationState({
        ...navigationState,
        height,
        current: label,
        stage: navigationState.stage === 'closed' ? 'opening' : 'transitioning',
        departedFromSubMenu: null,
      });
    } else {
      setIsMobileOpen(!isMobileOpen);
    }
  };

  const mobileSubMenuSpring = useSpring({
    height: isOpen ? height : 0,
  });

  const createOnFocusHandler = (buttonLabel) => {    
    return function (e) {
      console.log(`${buttonLabel}`, e);
    }
  }

  useLayoutEffect(() => {
    if (!isFullNav || !isOpen || !height || height === navigationState.height)
      return;
    setNavigationState({
      ...navigationState,
      height,
    });
  }, [height]);

  return (
    <StyledMenuItem      
      className={classnames({
        'is-open': isOpen,
        'is-previous-item-active': isPreviousItemActive,
      })}      
    >
      <button
        className={`nav-top-level__${label}`}
        ref={parentNavItem}
        type="button"
        onClick={toggleSubMenu}
        aria-expanded={ isOpen ? true : false}
        onFocus={createOnFocusHandler(label)}    
      >
        {label}        
      </button>
      <animated.div
        style={!isFullNav ? { ...mobileSubMenuSpring, overflow: 'hidden' } : {}}
      >
        <SubMenu
          spring={isFullNav ? { ...subMenuSpring } : {}}
          ref={ref}
          blocks={blocks}
          isOpen={isOpen}
          banner={includeBanner ? banner : null}
          label={label}
          navigationState={navigationState}
          setNavigationState={setNavigationState}
          parentNavItem={parentNavItem}
        />
      </animated.div>
    </StyledMenuItem>
  );
};

export default MenuDropdown;
